import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import ayurvedaLandImg from '@/assets/landing/ayurveda-land.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Ayurvedic Fasting Plan to Lose Weight and Improve Digestion',
			size: 'small',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: ayurvedaLandImg,
			customStyles: {
				marginTop: 'var(--size-24)',
				marginBottom: 'var(--size-24)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
